// client/src/pages/adminpages/InfluencerInfoPage.js
import React, { useState } from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import InfluencerInfoList from '../../components/admin/influencer/InfluencerInfoList';
import InfluencerInfoEditModal from '../../components/admin/influencer/InfluencerInfoEditModal';
import InfluencerBankEditModal from '../../components/admin/influencer/InfluencerBankEditModal';
import InfluencerContractEditModal from '../../components/admin/influencer/InfluencerContractEditModal';
import SNSFollowerEditModal from '../../components/admin/influencer/SNSFollowerEditModal';
import SNSUrlEditModal from '../../components/admin/influencer/SNSUrlEditModal';
import PerformanceStatDeleteModal from '../../components/admin/influencer/PerformanceStatDeleteModal';
import InfluencerPointAddModal from '../../components/admin/influencer/InfluencerPointAddModal';
import InfluencerPointDeductModal from '../../components/admin/influencer/InfluencerPointDeductModal';
import InfluencerWithdrawalModal from '../../components/admin/influencer/InfluencerWithdrawalModal';
import '../../styles/admin/AdminSummary.css';

const API_URL = process.env.REACT_APP_API_URL || '';

// 플랫폼별 표시할 단가 필드 정의 (server/api/utils/rateValidation.js와 일치)
const PLATFORM_RATE_FIELDS = {
  instagram: [
    { key: 'feed',  label: '피드' },
    { key: 'reels', label: '릴스' },
  ],
  blog: [
    { key: 'post',  label: '포스팅' },
  ],
  youtube: [
    { key: 'video',  label: '일반영상' },
    { key: 'shorts', label: '쇼츠' },
  ],
  tiktok: [
    { key: 'video',  label: '영상' },
  ],
};
// DB에는 한글 카테고리 문자열 그대로 저장됨 ('뷰티/패션', '음식/맛집' 등 8종)

const formatRate = (value) =>
  value != null ? `${value.toLocaleString()}원` : '-';

const formatDate = (dateVal) => {
  if (!dateVal) return null;
  const d = new Date(dateVal);
  if (isNaN(d.getTime())) return null;
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
};

function InfluencerInfoPage() {
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  
  // 수정 모달 상태
  const [showEditModal, setShowEditModal] = useState(false);
  const [showBankEditModal, setShowBankEditModal] = useState(false);
  const [showContractEditModal, setShowContractEditModal] = useState(false);
  const [showSNSFollowerModal, setShowSNSFollowerModal] = useState(false);
  const [showPerformanceStatDeleteModal, setShowPerformanceStatDeleteModal] = useState(false);
  const [showPointAddModal, setShowPointAddModal] = useState(false);
  const [showPointDeductModal, setShowPointDeductModal] = useState(false);
  const [selectedSNS, setSelectedSNS] = useState(null);
  const [showSNSUrlModal, setShowSNSUrlModal] = useState(false);
  const [selectedSNSForUrl, setSelectedSNSForUrl] = useState(null);
  const [message, setMessage] = useState('');

  // 회원탈퇴 관련
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [listRefreshToken, setListRefreshToken] = useState(0);
  const [verifiedStatusFilter, setVerifiedStatusFilter] = useState('approved');

  // 선택 시 상세 정보 조회
  const handleSelect = async (item) => {
    setSelected(item);
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/influencer/info/${item.userId}`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.ok) {
        setDetail(data.user);
      } else {
        setDetail(null);
      }
    } catch (err) {
      console.error('handleSelect error:', err);
      setDetail(null);
    }
    setLoading(false);
  };

  const handleSearch = () => {
    setPage(1);
    setSearch(searchInput);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // 승인 상태 필터 변경 시 1페이지로 초기화
  const handleStatusFilterChange = (e) => {
    setVerifiedStatusFilter(e.target.value);
    setPage(1);
  };

  // 회원탈퇴 완료 시 (모달 결과 화면에서 닫기를 누른 뒤 호출됨)
  const handleWithdrawn = () => {
    setDetail(null);
    setSelected(null);
    setListRefreshToken(t => t + 1);
  };

  // 수정 성공 시
  const handleEditSuccess = () => {
    setMessage('✅ 정보가 수정되었습니다. 해당 인플루언서가 로그인 중이라면 다음 로그인 시 변경사항이 반영됩니다.');
    
    // 상세 정보 다시 불러오기
    if (selected) {
      handleSelect(selected);
    }
    
    // 메시지 자동 제거
    setTimeout(() => {
      setMessage('');
    }, 5000);
  };

  // SNS 팔로워 수 수정
  const handleSNSFollowerEdit = (sns) => {
    setSelectedSNS(sns);
    setShowSNSFollowerModal(true);
  };

  // SNS URL 수정
  const handleSNSUrlEdit = (sns) => {
    setSelectedSNSForUrl(sns);
    setShowSNSUrlModal(true);
  };

  // 인플루언서 활동 정지/해제 토글
  const handleSuspendToggle = async () => {
    if (!detail || detail.verifiedStatus !== 'approved') return;

    const currentlySuspended = detail.isSuspended;

    if (currentlySuspended) {
      if (!window.confirm('이 인플루언서의 활동 정지를 해제하시겠습니까?\n\n해제 시 다시 로그인할 수 있습니다.')) {
        return;
      }

      try {
        const res = await fetch(
          `${API_URL}/api/admin/influencer/info/${detail.userId}/unsuspend`,
          { method: 'PATCH', credentials: 'include' }
        );
        const data = await res.json();

        if (data.ok) {
          setMessage('활동 정지가 해제되었습니다.');
          if (selected) handleSelect(selected);
          setTimeout(() => setMessage(''), 5000);
        } else {
          alert(data.message || '정지 해제에 실패했습니다.');
        }
      } catch (err) {
        console.error('unsuspend error:', err);
        alert('정지 해제 중 오류가 발생했습니다.');
      }
    } else {
      try {
        const warningsRes = await fetch(
          `${API_URL}/api/admin/influencer/info/${detail.userId}/suspend-warnings`,
          { credentials: 'include' }
        );
        const warningsData = await warningsRes.json();

        if (!warningsData.ok) {
          alert('경고 정보를 조회하는데 실패했습니다.');
          return;
        }

        const { activeApplications, pendingExchange, points, pendingExchangePoints } = warningsData.warnings;

        let warningMsg = '이 인플루언서를 활동 정지 처리하시겠습니까?\n\n';
        warningMsg += '⚠️ 정지 시 해당 인플루언서는 로그인할 수 없습니다.\n';
        warningMsg += '(계정 데이터는 보존되며, 언제든 해제할 수 있습니다.)\n\n';

        if (activeApplications > 0 || pendingExchange > 0 || points > 0 || pendingExchangePoints > 0) {
          warningMsg += '📋 현재 상태:\n';
          if (activeApplications > 0) warningMsg += `  • 진행 중인 프로젝트: ${activeApplications}건\n`;
          if (pendingExchange > 0) warningMsg += `  • 환전 대기 중: ${pendingExchange}건\n`;
          if (points > 0) warningMsg += `  • 보유 포인트: ${points.toLocaleString()}pt\n`;
          if (pendingExchangePoints > 0) warningMsg += `  • 환전 처리 중 포인트: ${pendingExchangePoints.toLocaleString()}pt\n`;
          warningMsg += '\n정지 중에도 프로젝트는 시스템에 의해 자동 처리됩니다.\n';
        }

        warningMsg += '\n정말 활동 정지 처리하시겠습니까?';

        if (!window.confirm(warningMsg)) return;

        const res = await fetch(
          `${API_URL}/api/admin/influencer/info/${detail.userId}/suspend`,
          { method: 'PATCH', credentials: 'include' }
        );
        const data = await res.json();

        if (data.ok) {
          setMessage('인플루언서가 활동 정지 처리되었습니다.');
          if (selected) handleSelect(selected);
          setTimeout(() => setMessage(''), 5000);
        } else {
          alert(data.message || '활동 정지 처리에 실패했습니다.');
        }
      } catch (err) {
        console.error('suspend error:', err);
        alert('활동 정지 처리 중 오류가 발생했습니다.');
      }
    }
  };

  const getVerifiedStatusLabel = (status) => {
    const labels = {
      approved: '승인',
      pending: '대기',
      rejected: '거절'
    };
    return labels[status] || status || '-';
  };

  const getContractStatusLabel = (status) => {
    const labels = {
      none: '미등록',
      sent: '발송완료',
      completed: '계약완료'
    };
    return labels[status] || status || '미등록';
  };

  const getPlatformLabel = (platform) => {
    const labels = {
      instagram: 'Instagram',
      youtube: 'YouTube',
      blog: 'Blog',
      tiktok: 'TikTok'
    };
    return labels[platform] || platform;
  };

  const getSNSStatusLabel = (status) => {
    const labels = {
      approved: '승인',
      rejected: '거절',
      submitted: '대기'
    };
    return labels[status] || status;
  };

  return (
    <AdminLayout title="인플루언서 정보관리">
      <div className="admin-grid">
        {/* 왼쪽: 목록 */}
        <div className="admin-section" style={{ height: 'calc(100vh - 120px)' }}>
          {/* 검색 */}
          <div className="admin-list__search">
            <div className="admin-list__search-grid">
              <input
                className="admin-list__search-input admin-list__search-input--full"
                type="text"
                placeholder="ID / 이름 / SNS 계정명 또는 URL 검색"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyPress={handleSearchKeyPress}
              />
            </div>
            <div className="admin-list__search-actions" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <select
                value={verifiedStatusFilter}
                onChange={handleStatusFilterChange}
                style={{ padding: '6px 8px', fontSize: 13 }}
              >
                <option value="approved">승인</option>
                <option value="pending">대기</option>
                <option value="rejected">거절</option>
                <option value="all">전체</option>
              </select>
              <button
                className="admin-list__search-button admin-list__search-button--primary"
                onClick={handleSearch}
              >
                검색
              </button>
            </div>
          </div>

          <InfluencerInfoList
            onSelect={handleSelect}
            selectedId={selected?.userId}
            search={search}
            page={page}
            onPageChange={setPage}
            refreshToken={listRefreshToken}
            verifiedStatusFilter={verifiedStatusFilter}
          />
        </div>

        {/* 오른쪽: 상세 정보 */}
        <div className="admin-section admin-section--wide" style={{ height: 'calc(100vh - 120px)', overflowY: 'auto' }}>
          <h3 className="admin-summary__title">인플루언서 상세 정보</h3>
          {!selected ? (
            <div className="admin-summary__empty">
              왼쪽 목록에서 인플루언서를 선택하세요.
            </div>
          ) : loading ? (
            <div className="admin-summary__loading">불러오는 중...</div>
          ) : detail ? (
            <div>
              {/* 성공 메시지 */}
              {message && (
                <div style={{
                  background: '#e8f5e9',
                  color: '#2e7d32',
                  padding: 12,
                  borderRadius: 4,
                  marginBottom: 20,
                  fontSize: 14
                }}>
                  {message}
                </div>
              )}

              {/* 1. 기본 정보 */}
              <section style={{ marginBottom: 32 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    기본 정보
                  </h4>
                  <button
                    className="admin-section__button"
                    onClick={() => setShowEditModal(true)}
                    style={{ padding: '6px 14px', fontSize: 13 }}
                  >
                    수정
                  </button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>인플루언서 ID</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.userId}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>이름</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.userName}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>이메일</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.email}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>전화번호</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.phoneNumber}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>주소</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.userAddress}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>가입일</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{new Date(detail.registeredAt).toLocaleString('ko-KR')}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>승인 상태</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span className={`admin-list__item-badge ${
                      detail.verifiedStatus === 'approved' ? 'admin-list__item-badge--success' : 
                      detail.verifiedStatus === 'rejected' ? 'admin-list__item-badge--danger' :
                      'admin-list__item-badge--warning'
                    }`}>
                      {getVerifiedStatusLabel(detail.verifiedStatus)}
                    </span>
                    {detail.isSuspended && (
                      <span className="admin-list__item-badge admin-list__item-badge--danger">
                        활동 정지
                      </span>
                    )}
                    {detail.verifiedStatus === 'approved' && (
                      <button
                        onClick={handleSuspendToggle}
                        style={{
                          padding: '4px 10px',
                          fontSize: 12,
                          backgroundColor: detail.isSuspended ? '#16a34a' : 'var(--admin-color-danger)',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer'
                        }}
                      >
                        {detail.isSuspended ? '정지 해제' : '활동 정지'}
                      </button>
                    )}
                    {/* 회원탈퇴 — 승인 상태와 무관하게 항상 노출 (pending/rejected 유저도 탈퇴 대상) */}
                    <button
                      onClick={() => setShowWithdrawalModal(true)}
                      style={{
                        padding: '4px 10px',
                        fontSize: 12,
                        backgroundColor: '#7f1d1d',
                        color: 'white',
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer'
                      }}
                    >
                      회원탈퇴
                    </button>
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>마케팅 수신 동의</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.marketingOption ? '예' : '아니오'}</div>
                </div>
              </section>

              {/* 2. 포인트 정보 */}
              <section style={{ marginBottom: 32 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    포인트 정보
                  </h4>
                  <div className="admin-section__actions" style={{ margin: 0 }}>
                    <button
                      className="admin-section__button"
                      onClick={() => setShowPointAddModal(true)}
                      style={{ padding: '6px 14px', fontSize: 13, backgroundColor: 'var(--admin-color-success)', borderColor: 'var(--admin-color-success)' }}
                    >
                      포인트 지급
                    </button>
                    <button
                      className="admin-section__button"
                      onClick={() => setShowPointDeductModal(true)}
                      style={{ padding: '6px 14px', fontSize: 13, backgroundColor: 'var(--admin-color-danger)', borderColor: 'var(--admin-color-danger)' }}
                    >
                      포인트 차감
                    </button>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>보유 포인트</div>
                  <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--admin-color-primary)' }}>
                    {(detail.points || 0).toLocaleString()}pt
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>환전 처리 중</div>
                  <div style={{ fontSize: 16, color: 'var(--admin-color-warning)' }}>
                    {(detail.pendingExchangePoints || 0).toLocaleString()}pt
                  </div>
                </div>
              </section>

              {/* 3. 프리랜서 계약 정보 */}
              <section style={{ marginBottom: 32 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    프리랜서 계약 정보
                  </h4>
                  <button
                    className="admin-section__button"
                    onClick={() => setShowContractEditModal(true)}
                    style={{ padding: '6px 14px', fontSize: 13 }}
                  >
                    수정
                  </button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>계약 상태</div>
                  <div>
                    <span className={`admin-list__item-badge ${detail.contractMail?.status === 'completed' ? 'admin-list__item-badge--success' : 'admin-list__item-badge--secondary'}`}>
                      {getContractStatusLabel(detail.contractMail?.status)}
                    </span>
                  </div>
                  
                  {detail.contractMail?.completedAt && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>계약 완료일</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>{new Date(detail.contractMail.completedAt).toLocaleString('ko-KR')}</div>
                    </>
                  )}
                  
                  {detail.contractMail?.lastSentAt && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>마지막 발송일</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>{new Date(detail.contractMail.lastSentAt).toLocaleString('ko-KR')}</div>
                    </>
                  )}
                  
                  {detail.contractMail?.adminMemo && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>관리자 메모</div>
                      <div style={{ whiteSpace: 'pre-wrap', color: 'var(--admin-text-main)' }}>{detail.contractMail.adminMemo}</div>
                    </>
                  )}
                </div>
              </section>

              {/* 4. 통장 정보 */}
              <section style={{ marginBottom: 32 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    통장 정보
                  </h4>
                  <button
                    className="admin-section__button"
                    onClick={() => setShowBankEditModal(true)}
                    style={{ padding: '6px 14px', fontSize: 13 }}
                  >
                    수정
                  </button>
                </div>
                {detail.bankAccount?.accountNumber ? (
                  <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                    <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>예금주</div>
                    <div style={{ color: 'var(--admin-text-main)' }}>{detail.bankAccount.holderName || '-'}</div>
                    
                    <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>은행명</div>
                    <div style={{ color: 'var(--admin-text-main)' }}>{detail.bankAccount.bankName || detail.bankAccount.bankNameCustom || '-'}</div>
                    
                    <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>계좌번호</div>
                    <div style={{ color: 'var(--admin-text-main)' }}>{detail.bankAccount.accountNumber}</div>
                    
                    {detail.bankAccount.updatedAt && (
                      <>
                        <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>등록일</div>
                        <div style={{ color: 'var(--admin-text-main)' }}>{new Date(detail.bankAccount.updatedAt).toLocaleString('ko-KR')}</div>
                      </>
                    )}
                  </div>
                ) : (
                  <div style={{ color: 'var(--admin-text-muted)', padding: '12px 0' }}>등록된 통장 정보가 없습니다.</div>
                )}
              </section>

              {/* 5. SNS 계정 정보 */}
              <section style={{ marginBottom: 32 }}>
                <h4 style={{ 
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)',
                  color: 'var(--admin-color-primary)',
                  marginTop: 0
                }}>
                  SNS 계정 정보
                </h4>
                {detail.snsInfo && detail.snsInfo.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {detail.snsInfo.map((sns, index) => (
                      <div 
                        key={index}
                        style={{
                          padding: 16,
                          background: 'var(--admin-bg-body)',
                          borderRadius: 8,
                          border: '1px solid var(--admin-border-color)'
                        }}
                      >
                        <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px 16px', fontSize: '14px' }}>
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>플랫폼</div>
                          <div style={{ color: 'var(--admin-text-main)' }}>{getPlatformLabel(sns.platform)}</div>
                          
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>계정명</div>
                          <div style={{ color: 'var(--admin-text-main)' }}>{sns.accountName}</div>
                          
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>팔로워 수</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ color: 'var(--admin-text-main)' }}>{(sns.followerCount || 0).toLocaleString()}명</span>
                            {sns.status === 'approved' && (
                              <button
                                className="admin-section__button"
                                onClick={() => handleSNSFollowerEdit(sns)}
                                style={{ padding: '4px 10px', fontSize: 12 }}
                              >
                                수정
                              </button>
                            )}
                          </div>
                          
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>URL</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            {sns.url
                              ? (
                                <a
                                  href={sns.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: 'var(--admin-color-primary)', textDecoration: 'none', wordBreak: 'break-all' }}
                                >
                                  {sns.url}
                                </a>
                              )
                              : <span style={{ color: 'var(--admin-text-muted)' }}>미등록</span>
                            }
                            {sns.status === 'approved' && (
                              <button
                                className="admin-section__button"
                                onClick={() => handleSNSUrlEdit(sns)}
                                style={{ padding: '4px 10px', fontSize: 12, flexShrink: 0 }}
                              >
                                수정
                              </button>
                            )}
                          </div>
                          
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>승인 상태</div>
                          <div>
                            <span className={`admin-list__item-badge ${
                              sns.status === 'approved' ? 'admin-list__item-badge--success' : 
                              sns.status === 'rejected' ? 'admin-list__item-badge--danger' : 'admin-list__item-badge--warning'
                            }`}>
                              {getSNSStatusLabel(sns.status)}
                            </span>
                          </div>

                          {/* 희망 단가 */}
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)', alignSelf: 'start' }}>희망 단가</div>
                          <div>
                            {(PLATFORM_RATE_FIELDS[sns.platform] || []).map(({ key, label }) => (
                              <div key={key} style={{ fontSize: 13, color: 'var(--admin-text-main)', lineHeight: 1.8 }}>
                                <span style={{ color: 'var(--admin-text-sub)', marginRight: 4 }}>{label}:</span>
                                {formatRate(sns.desiredRate?.[key])}
                              </div>
                            ))}
                            {!(PLATFORM_RATE_FIELDS[sns.platform] || []).length && (
                              <span style={{ color: 'var(--admin-text-muted)' }}>-</span>
                            )}
                          </div>

                          {/* 카테고리 */}
                          <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)', alignSelf: 'start' }}>카테고리</div>
                          <div>
                            {sns.categories && sns.categories.length > 0
                              ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                  {sns.categories.map(cat => (
                                    <span
                                      key={cat}
                                      style={{
                                        display: 'inline-block',
                                        background: 'var(--admin-bg-body)',
                                        border: '1px solid var(--admin-border-color)',
                                        borderRadius: 4,
                                        padding: '1px 8px',
                                        fontSize: 12,
                                        color: 'var(--admin-text-sub)'
                                      }}
                                    >
                                      {cat}
                                    </span>
                                  ))}
                                </div>
                              )
                              : <span style={{ color: 'var(--admin-text-muted)' }}>미설정</span>
                            }
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ color: 'var(--admin-text-muted)', padding: '12px 0' }}>등록된 SNS 계정이 없습니다.</div>
                )}
              </section>

              {/* 6. 프로젝트 알림 동의 */}
              <section style={{ marginBottom: 32 }}>
                <h4 style={{
                  marginBottom: 16,
                  paddingBottom: 8,
                  borderBottom: '2px solid var(--admin-color-primary)',
                  color: 'var(--admin-color-primary)',
                  marginTop: 0
                }}>
                  프로젝트 알림 동의
                </h4>
                {(() => {
                  const consent = detail.projectAlertConsent;
                  return (
                    <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '8px 16px', fontSize: '14px' }}>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>이메일 알림</div>
                      <div>
                        <span className={`admin-list__item-badge ${consent?.email ? 'admin-list__item-badge--success' : 'admin-list__item-badge--warning'}`}>
                          {consent?.email ? '동의' : '미동의'}
                        </span>
                        {consent?.email && consent?.emailConsentAt && (
                          <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--admin-text-muted)' }}>
                            {formatDate(consent.emailConsentAt)} 동의
                          </span>
                        )}
                        {!consent?.email && consent?.emailWithdrawnAt && (
                          <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--admin-text-muted)' }}>
                            {formatDate(consent.emailWithdrawnAt)} 철회
                          </span>
                        )}
                      </div>

                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>SMS 알림</div>
                      <div>
                        <span className={`admin-list__item-badge ${consent?.sms ? 'admin-list__item-badge--success' : 'admin-list__item-badge--warning'}`}>
                          {consent?.sms ? '동의' : '미동의'}
                        </span>
                        {consent?.sms && consent?.smsConsentAt && (
                          <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--admin-text-muted)' }}>
                            {formatDate(consent.smsConsentAt)} 동의
                          </span>
                        )}
                        {!consent?.sms && consent?.smsWithdrawnAt && (
                          <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--admin-text-muted)' }}>
                            {formatDate(consent.smsWithdrawnAt)} 철회
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })()}
              </section>

              {/* 7. 성과 통계 */}
              <section>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    성과 통계
                  </h4>
                  <button
                    className="admin-section__button"
                    onClick={() => setShowPerformanceStatDeleteModal(true)}
                    style={{ padding: '6px 14px', fontSize: 13, backgroundColor: 'var(--admin-color-danger)', borderColor: 'var(--admin-color-danger)' }}
                  >
                    만족도 점수 삭제
                  </button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>완료한 프로젝트</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{(detail.performanceStats?.totalProjects || 0).toLocaleString()}개</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>평균 만족도</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>
                    {detail.performanceStats?.satisfactionScore 
                      ? `${detail.performanceStats.satisfactionScore.toFixed(1)}점 / 5.0점`
                      : '평가 없음'}
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>평가 받은 횟수</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{(detail.performanceStats?.satisfactionCount || 0).toLocaleString()}회</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>총 선정된 횟수</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{(detail.performanceStats?.totalSelections || 0).toLocaleString()}회</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>계약 미진행 횟수</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{(detail.performanceStats?.contractCancelCount || 0).toLocaleString()}회</div>
                </div>
              </section>
            </div>
          ) : null}
        </div>
      </div>

      {/* 수정 모달들 */}
      <InfluencerInfoEditModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        influencer={detail}
        onSuccess={handleEditSuccess}
      />

      {/* 통장 정보 수정 모달 */}
      <InfluencerBankEditModal
        open={showBankEditModal}
        onClose={() => setShowBankEditModal(false)}
        influencer={detail}
        onSuccess={handleEditSuccess}
      />

      {/* 계약 상태 수정 모달 */}
      <InfluencerContractEditModal
        open={showContractEditModal}
        onClose={() => setShowContractEditModal(false)}
        influencer={detail}
        onSuccess={handleEditSuccess}
      />

      {/* SNS 팔로워 수 수정 모달 */}
      <SNSFollowerEditModal
        open={showSNSFollowerModal}
        onClose={() => {
          setShowSNSFollowerModal(false);
          setSelectedSNS(null);
        }}
        snsInfo={selectedSNS}
        onSuccess={handleEditSuccess}
      />

      {/* SNS URL 수정 모달 */}
      <SNSUrlEditModal
        open={showSNSUrlModal}
        onClose={() => {
          setShowSNSUrlModal(false);
          setSelectedSNSForUrl(null);
        }}
        snsInfo={selectedSNSForUrl}
        onSuccess={handleEditSuccess}
      />

      {/* 만족도 점수 삭제 모달 */}
      <PerformanceStatDeleteModal
        open={showPerformanceStatDeleteModal}
        onClose={() => setShowPerformanceStatDeleteModal(false)}
        userId={selected?.userId}
        onSuccess={handleEditSuccess}
      />

      {/* 포인트 지급 모달 */}
      <InfluencerPointAddModal
        open={showPointAddModal}
        onClose={() => setShowPointAddModal(false)}
        influencer={detail}
        onSuccess={handleEditSuccess}
      />

      {/* 포인트 차감 모달 */}
      <InfluencerPointDeductModal
        open={showPointDeductModal}
        onClose={() => setShowPointDeductModal(false)}
        influencer={detail}
        onSuccess={handleEditSuccess}
      />

      {/* 회원탈퇴 모달 */}
      <InfluencerWithdrawalModal
        open={showWithdrawalModal}
        onClose={() => setShowWithdrawalModal(false)}
        userId={detail?.userId}
        onWithdrawn={handleWithdrawn}
      />
    </AdminLayout>
  );
}

export default InfluencerInfoPage;
